import { render, staticRenderFns } from "./ActorEditBackground.vue?vue&type=template&id=e2588aae&scoped=true&"
import script from "./ActorEditBackground.vue?vue&type=script&lang=js&"
export * from "./ActorEditBackground.vue?vue&type=script&lang=js&"
import style0 from "./ActorEditBackground.vue?vue&type=style&index=0&id=e2588aae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2588aae",
  null
  
)

export default component.exports